export default __webpack_public_path__ + "static/media/cern-medium.cf74673e.woff";